import { render } from "./open-orders-block.vue?vue&type=template&id=1f54ace8&scoped=true"
import script from "./open-orders-block.vue?vue&type=script&lang=js"
export * from "./open-orders-block.vue?vue&type=script&lang=js"

import "./open-orders-block.vue?vue&type=style&index=0&id=1f54ace8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f54ace8"]])

export default __exports__